"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const WebVitals = () => {
    const capture = (0, index_1.useCapture)();
    (0, index_1.useReportWebVitals)((metric) => {
        capture(metric.name, metric);
    });
    return null;
};
exports.default = WebVitals;
